/**
 * 平台 AI 改版删掉的页面 → 新家。旧书签、以及库里还没下线的旧菜单（sys.menu）点进来不再是空页。
 * Skills 并进 Agent（工具 / Prompt）；Context → 预设；Activity → 用量；AI Settings → 模型（计费设置在用量里）；
 * 判断 → AI 函数；旧 Prompt 的 ns/name 详情 → AI 函数里的 Prompt 型。
 */
import { Navigate, useParams } from 'react-router-dom'

export const LEGACY_PLATFORM_AI_REDIRECTS: { path: string; to: string }[] = [
  { path: 'platform/ai', to: '/platform/ai-agents' },
  { path: 'platform/ai-skills', to: '/platform/ai-agents' },
  { path: 'platform/ai-skills/:id', to: '/platform/ai-agents' },
  { path: 'platform/ai-context', to: '/platform/ai-presets' },
  { path: 'platform/ai-activity', to: '/platform/ai-usage' },
  { path: 'platform/ai-settings', to: '/platform/models' },
  { path: 'platform/ai-tools', to: '/platform/ai-agents' },
  { path: 'platform/ai-tools/*', to: '/platform/ai-agents' },
  { path: 'platform/judgments', to: '/platform/ai-functions' },
  { path: 'platform/judgments/:slug', to: '/platform/ai-functions/:slug' },
  { path: 'platform/ai-prompts/:namespace/:name', to: '/platform/ai-functions/:namespace/:name' },
]

/**
 * 2026-10-16 旧菜单清理（Frank 定，main-api 迁移 e6a1c9d47b2f 删菜单行）删掉的 Account Settings 页与平台 Features 页 → 新家。
 * Skills 并进 Agent；Context → 配置页的术语表；Activity → 用量（审批在对话卡片里）；AI Settings 的 provider key 已在 Vault；
 * Classification（旧分类标签，已退役）→ Task Kinds；Features（已废弃）→ Roles & Permissions；
 * 平台 Task Kind Classification（飞轮调参页，Frank 在 task kind 拷问 Q6 / Q25 定删，main-api 迁移 a4d2c7e9f1b3）→ Task Kinds。
 */
export const LEGACY_TENANT_SETTINGS_REDIRECTS: { path: string; to: string }[] = [
  { path: 'ai-skills', to: '/ai-agents' },
  { path: 'ai-skills/:id', to: '/ai-agents' },
  { path: 'ai-context', to: '/settings/configuration/glossary' },
  { path: 'ai-activity', to: '/settings/ai-usage' },
  { path: 'settings/ai', to: '/settings/vault' },
  { path: 'classification', to: '/task-kinds' },
  { path: 'capability-management', to: '/roles-permissions' },
  { path: 'task-kind-classification', to: '/task-kinds' },
]

/** `to` 里的 `:param` 用当前路由的参数填 */
export function LegacyRedirect({ to }: { to: string }) {
  const params = useParams()
  const target = to.replace(/:([A-Za-z]+)/g, (_, k: string) => encodeURIComponent(params[k] ?? ''))
  return <Navigate to={target} replace />
}
